// extracted by mini-css-extract-plugin
export default {"noc-incidents-chart--table":"style_noc-incidents-chart--table__z3c11"};